import React, { ReactNode } from "react";
import format from "./formatNumbers";

export default function getLimits(min?: number | null, max?: number | null): ReactNode | null {
  return min && max ? <small>{`${format.price(min)} - ${format.price(max)}`}</small> : null;
}
